import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import "./i18n";
import MainPage from "./pages/main/MainPage";
import OurMission from "./pages/OurMission/OurMission";
import BlogListPage from "./pages/BlogList/BlogListPage";
import BlogDetailWithFormPage from "./pages/FormPage/BlogDetailWithFormPage";
import BlogDetailSection from "./components/BlogDetailSection/BlogDetailSection";
import DocumentsPage from "./pages/Documents/DocumentsPage";
import KvkkPage from "./pages/Kvkk/KvkkPage";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <Router>
      <Routes>
        {/* Dil kodlu rotalar */}
        <Route path="/:lang" element={<MainPage />} />
        <Route path="/:lang/contact-us" element={<MainPage scrollToContact={true} />} />
        <Route path="/:lang/blog" element={<BlogListPage />} />
        <Route path="/:lang/blog/report-form" element={<BlogDetailWithFormPage />} />
        <Route path="/:lang/blog/:id" element={<BlogDetailSection />} />
        <Route path="/:lang/our-mission" element={<OurMission />} />
        <Route path="/:lang/documents" element={<DocumentsPage />} />
        <Route path="/:lang/kvkk" element={<KvkkPage />} />

        {/* Dil kodsuz rotalar (geriye dönük uyumluluk) */}
        <Route path="/" element={<MainPage />} />
        <Route path="/contact-us" element={<MainPage scrollToContact={true} />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/report-form" element={<BlogDetailWithFormPage />} />
        <Route path="/blog/:id" element={<BlogDetailSection />} />
        <Route path="/our-mission" element={<OurMission />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/kvkk" element={<KvkkPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ScrollToTop />
    </Router>
  );
}

export default App;
